import React from 'react';
import { homeDetails } from '../../data/quote';
import { formatCurrency } from '../../utils/currency';
export function HomeSummary() {
  return <section aria-label="Home and loan amount" className="rounded-[28px] bg-navy-50 p-5 sm:p-6" data-id="element-64" data-mp="lu2yn12qz3wn">
      <dl className="grid gap-5 sm:grid-cols-[1.3fr_1fr_1fr] sm:gap-0 sm:divide-x sm:divide-navy-200" data-id="element-65" data-mp="10qtytck8wjnb">
        <div className="sm:pr-6" data-id="element-66" data-mp="vsin0wae3z2g">
          <dt className="text-sm font-bold text-navy-500" data-id="element-67" data-mp="19pxee6k7egx2">Purchase price</dt>
          <dd className="mt-1 text-[34px] font-black leading-none tabular-nums tracking-tight" data-id="element-68" data-mp="19nui54sgjrjw">
            {formatCurrency(homeDetails.purchasePrice)}
          </dd>
          <dd className="mt-2 text-xs font-bold text-navy-500" data-id="element-69" data-mp="1jfh2prqor2zb">{homeDetails.term}</dd>
        </div>
        <div className="sm:px-6" data-id="element-70" data-mp="1ehfhb05serko">
          <dt className="text-sm font-bold text-navy-500" data-id="element-71" data-mp="1sgoml4sgg19v">Down payment</dt>
          <dd className="mt-1 text-xl font-black tabular-nums" data-id="element-72" data-mp="1sgydculbqcgm">{formatCurrency(homeDetails.downPaymentAmount)}</dd>
          <dd className="mt-1.5" data-id="element-73" data-mp="1oda509ovbcub">
            <span className="inline-flex rounded-full bg-white px-2.5 py-0.5 text-xs font-extrabold text-navy" data-id="element-74" data-mp="saupx5mdlxje">
              {homeDetails.downPaymentPercent} down
            </span>
          </dd>
        </div>
        <div className="sm:pl-6" data-id="element-75" data-mp="11ardt50xysde">
          <dt className="text-sm font-bold text-navy-500" data-id="element-76" data-mp="119pu6c5v0xk2">Loan amount</dt>
          <dd className="mt-1 text-xl font-black tabular-nums" data-id="element-77" data-mp="16ax16906hspo">{formatCurrency(homeDetails.loanAmount)}</dd>
        </div>
      </dl>
    </section>;
}